const infographic = "icon-ebook.png";
const customer_story = "icon-customer-story.png";
const white_paper = "icon-whitepaper.png";
const analyst_report = "icon-analyst-report.png";
const video = "icon-videos.png";
const data_sheet ="icon-data-sheet.png";
const datasheet ="icon-data-sheet.png";
const demo = "icon-demo.png";
const ebook = "icon-ebook.png";
const brief_guide =  "icon-brief-guide.png";
const interactive_tour = "icon-interactive-tours.png";
const kits = "icon-resource-kits.png";
const webinar =  "icon-webinars.png";
const podcast = "icon-podcasts.png";
const assessment_tool = "icon-assessment-tool.png";
const dr_jaspersoft_webinar = "icon-webinars-dr-jaspersoft.png";

export default {
    "eBook": infographic,
    "Customer story": customer_story,
    "White paper": white_paper,
    "Whitepaper" : white_paper,
    "Analyst report": analyst_report,
    "Video": video,
    "Data sheet": data_sheet,
    "Datasheet" : datasheet,
    "Demo": demo,
    "e-book": ebook,
    "Solution brief": brief_guide,
    "Infographic": infographic,
    "Interactive tour": interactive_tour,
    "Resource kit": kits,
    "Technical brief": brief_guide,
    "Technical guide": brief_guide,
    "Technical case study": ebook,
    "Webinar": webinar,
    "Content kit": kits,
    "Guide" : brief_guide,
    "Podcast" : podcast,
    "Assessment tool": assessment_tool,
    "Dr. Jaspersoft Webinar": dr_jaspersoft_webinar
}



